import React from 'react'
import { AppBar, Box, IconButton, Toolbar } from '@mui/material'
import { Menu as MenuIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import medendoLogo from '../../../assets/medendo_logo.png'
import { headerHeight } from '../shellSizes'
import { shellHairline, sidePanelColor } from '../../../theme'

// Desktop has no shared header band at all: the sidebar owns its own logo and toggle (see
// Sidebar.tsx), and pages start just below a small gap at the top of the viewport.
// Mobile still needs this: the drawer is a hidden overlay there, so something visible
// has to stay on screen to open it.
export const AppToolbar: React.FC<{
    isMobile: boolean
    onMenuClick: () => void
}> = (props) => {
    const { t } = useTranslation()

    if (!props.isMobile) return null

    return (
        <AppBar
            position="fixed"
            sx={{
                height: headerHeight,
                // The side panels' tone, a shade darker than the canvas, so the page below reads as its own surface
                bgcolor: sidePanelColor,
                borderBottom: '1px solid',
                borderColor: shellHairline,
                color: 'text.primary',
                boxShadow: 'none',
                borderRadius: 0,
                padding: 0,
                pt: 1,
            }}
        >
            <Toolbar sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <IconButton onClick={props.onMenuClick} aria-label={t('encounter.menu_open')}>
                    <MenuIcon />
                </IconButton>
                <Box sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
                    <img src={medendoLogo} alt="" width={140} />
                </Box>
            </Toolbar>
        </AppBar>
    )
}
